module.exports = __webpack_public_path__ + "static/media/icon_notice_g.a3222c18.svg";